import styled from 'styled-components'

export default styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-template-areas: 'start end';

  @media screen and (min-width: 940px) {
    grid-template-columns: 1fr 1fr;
  }
`
